import { C } from "../../shared/theme";

// The Goal field's dropdown in the Key Date and habit editors (the task editor's is a TaskLinkField): "No goal", then
// `options` (goalChoices). The caller draws the label, pointing at `id`; `style` is that editor's field style.
// onChange gets the goal's id, or "" for none.
export function GoalSelect({ id, options, value, onChange, style }) {
  return (
    <select id={id} value={value || ""} onChange={e => onChange(e.target.value)} style={{ ...style, color: value ? C.text : C.textMid }}>
      <option value="">No goal</option>
      {options.map(g => <option key={g.id} value={g.id}>{g.title}</option>)}
    </select>
  );
}
